import React, { useState } from 'react';
import './settings.css';
import { goBack, goToScreenAndReset } from '../../actions/router';
import { connect } from 'react-redux';
import { TITLE_SCREEN } from '../../constants/routes';
import { exitGame } from '../../actions/active-game';
import {
    changeFontSize,
    toggleAudio,
    toggleTimedGames,
} from '../../actions/settings';
import { Paragraph } from '../../components/paragraph';
import { Panel } from '../../components/panel';
import classNames from 'classnames';
import { GameSettings } from './game-settings';
import { AccessibilitySettings } from './accessibility-settings';

const SettingsScreen = props => {
    const {
        previousPage,
        resumeGame,
        exitCurrentGame,
        audio,
        setAudio,
        fontSize,
        setFontSize,
        timedGames,
        setTimedGames,
    } = props;

    const shouldHideExitGame = previousPage === TITLE_SCREEN;

    const [activeMenu, setActiveMenu] = useState('game');

    const gameMenuOptionClasses = classNames({
        'settings-page__menu-option': true,
        'settings-page__menu-option--active': activeMenu === 'game',
    });

    const accessibilityMenuOptionClasses = classNames({
        'settings-page__menu-option': true,
        'settings-page__menu-option--active': activeMenu === 'accessibility',
    });

    return (
        <div className="settings-page">
            <div className="settings-page__menu">
                <div
                    className="settings-page__menu-options"
                    role="banner"
                    aria-label="settings page options"
                >
                    <button
                        className={gameMenuOptionClasses}
                        onClick={() => setActiveMenu('game')}
                    >
                        <Paragraph
                            colorScheme={
                                activeMenu === 'game' ? 'dark' : 'light'
                            }
                            fontSize="large"
                            withSpacing={false}
                            textAlign="center"
                        >
                            Game
                        </Paragraph>
                    </button>
                    <button
                        className={accessibilityMenuOptionClasses}
                        onClick={() => setActiveMenu('accessibility')}
                    >
                        <Paragraph
                            colorScheme={
                                activeMenu === 'accessibility'
                                    ? 'dark'
                                    : 'light'
                            }
                            fontSize="large"
                            withSpacing={false}
                            textAlign="center"
                        >
                            Accessibility
                        </Paragraph>
                    </button>
                </div>
                <Panel
                    withSpacing={false}
                    withPadding={false}
                    currentPage={activeMenu + 'settings'}
                    fullHeight
                >
                    <div className="settings-page__content">
                        {activeMenu === 'game' ? (
                            <GameSettings
                                shouldHideExitGame={shouldHideExitGame}
                                exitGame={() => exitCurrentGame()}
                                resumeGame={() => resumeGame()}
                                audio={audio}
                                setAudio={() => setAudio(!audio)}
                                previousPage={previousPage}
                            />
                        ) : (
                            <AccessibilitySettings
                                fontSize={fontSize}
                                setFontSize={setFontSize}
                                timedGames={timedGames}
                                setTimedGames={setTimedGames}
                            />
                        )}
                    </div>
                </Panel>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        previousPage: state.router.history[state.router.history.length - 2],
        timedGames: state.settings.accessibility.timedGames,
        audio: state.settings.audio,
        fontSize: state.settings.accessibility.fontSize,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        resumeGame: () => {
            dispatch(goBack());
        },
        exitCurrentGame: () => {
            dispatch(goToScreenAndReset(TITLE_SCREEN));
            dispatch(exitGame());
        },
        setAudio: boolean => {
            dispatch(toggleAudio(boolean));
        },
        setFontSize: size => {
            dispatch(changeFontSize(size));
        },
        setTimedGames: boolean => {
            dispatch(toggleTimedGames(boolean));
        },
    };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(SettingsScreen);
export { connected as SettingsScreen };
